import styled, { keyframes } from "styled-components";
import { Checkbox } from 'antd';
const isMobile = window.innerWidth < 768;

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
`;

export const StyledAuth = styled.div`
    height: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 50px;
    padding-top: ${isMobile ? '60px'  : '160px' };
    background-color: rgba(251, 247, 240, 1);
    
    &.fade-in {
        animation: ${fadeIn} 300ms ease-in;
    }

    &.fade-out {
        animation: ${fadeOut} 300ms ease-out;
    }
`;

export const StyledCheckbox = styled(Checkbox)`
    font-size: 18px !important;
    color: rgba(76, 76, 77, 1) !important;
    line-height: 20px !important;
    margin-bottom: 0px !important;

    .ant-checkbox-checked .ant-checkbox-inner {
        background-color: orange !important;
        border-color: orange !important;
    }

    .ant-checkbox-inner {
        border-color: rgb(150, 155, 171) !important;
    }
`;

export const MethodButton = styled.button<{ $variant?: "google" | "default" }>`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 14px 20px;
  border-radius: 12px;
  border: 1.5px solid rgba(150, 155, 171, 0.35);
  background: #fff;
  color: #0A033C;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.15s, box-shadow 0.15s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }

  .anticon {
    font-size: 20px;
  }
`;